import HeroImg from '../assets/img/pictures/contact.jpg';
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <>
    		<div class="site-breadcrumb" style={{backgroundImage: `url(${HeroImg})`}}>
			<div class="container">
				<div class="site-breadcrumb-wpr">
					<h2 class="breadcrumb-title">Contact Us</h2>
					<ul class="breadcrumb-menu clearfix">
						<li><Link to="/">Home</Link></li>
						<li class="active">Contact Us</li>
					</ul>
				</div>
			</div>
		</div>

    <div class="contact-area de-padding">
			<div class="container">
				<div class="contact-wpr">
					<div class="row g-5">
						<div class="col-xl-4">
							<div class="contact-sdebar">
								<div class="contact-up-title">
									<h2 class="heading-1">
										Get in Touch
									</h2>
								</div>
								<div class="addr-home">
									<div class="addr-box">
										<div class="addr-box-single">
											<div class="addr-icon">
												<i class="icofont-google-map"></i>
											</div>
											<div class="addr-desc">
												<h5>Location</h5>
												<p class="mb-0">
                        Two Side Ankawa <br /> Eribil, Iraq, 44003
												</p>
											</div>
										</div>
										<div class="addr-box-single">
											<div class="addr-icon">
												<i class="icofont-phone"></i>
											</div>
											<div class="addr-desc">
												<h5>Make a Call</h5>
												<a href="https://wa.link/3b9v14" className='mb-0' target="_blank" rel="noopener noreferrer">+964-7500212148</a>
											</div>
										</div>
										<div class="addr-box-single">
											<div class="addr-icon">
												<i class="icofont-email"></i>
											</div>
											<div class="addr-desc">
												<h5>Our Email</h5>
												<a href="mailto:info@hallgord.com" className='mb-0'>info@hallgord.com</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-8">
							<div class="contact-home pl-30">
              <form action="mailto:info@hallgord.com" method="post" class="contact-form contact-cnt">
									<div class="contact-form-title mb-30">
										<h2 class="heading-1">
											Send us a message
										</h2>
									</div>
									<div class="row">
										<div class="col-xl-6">
											<div class="col-md-12">
												<div class="form-group">
													<input type="text" class="form-control input-style-2" id="name" name="name" placeholder="Your Full Name*" />
													<span class="alert alert-error"></span>
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<input type="email" class="form-control input-style-2" id="email" name="email" placeholder="Your Email Address*" />
													<span class="alert alert-error"></span>
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<input type="text" class="form-control input-style-2" id="phone" name="phone" placeholder="Phone Number" />
													<span class="alert alert-error"></span>
												</div>
											</div>
										</div>
										<div class="col-xl-6">
											<div class="col-md-12">
												<textarea class="form-control input-style-2" id="comment" name="comments" placeholder="Your Message..."></textarea>
												<div class="alert-notification">
													<div id="message" class="alert-msg"></div>
												</div>
											</div>
										</div>
									</div>
									<div class="sub-btn d-flex align-items-center justify-content-between">
										<div class="form-check">
											<input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
											<label class="form-check-label" for="flexCheckDefault">
												I agree to the <span>Terms &amp; Conditions</span> 
											</label>
										</div>
										<div class="contact-sub-btn">
											<button type="submit" name="submit" id="submit" class="btn-submit">
												Send Message 
												<i class="fas fa-chevron-right"></i>
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    <div class="g-map-area">
			<div class="g-map--wrapper text-center">
      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d25745.77758036566!2d43.992519!3d36.234096!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40071f4a61f04cef%3A0x3d766685a7a0ea1f!2sAnkawa%2C%20Erbil%2C%20Iraq!5e0!3m2!1sen!2slk!4v1699947447622!5m2!1sen!2slk" width="600" height="450" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
			</div>
		</div>
    </>
  );
}